export default theme => ({
  wrapper: {
    position: 'relative',
    overflow: 'hidden',
    margin: 15
  },
  container: {
    color: '#fff !important',
    padding: '10px 10px 0 10px'
  },
  thumbnail: {
    width: '100%',
    maxWidth: '100%',
    minHeight: 150,
    maxHeight: 270,
    // margin: 2,
    background: 'url(/caffecinema/img/placeholder.png) no-repeat center center',
  },
  title: {
    // position: 'absolute',
    // bottom: 10, left: 0, right: 0,
    lineHeight: 2,
    marginBottom: 8,
    fontWeight: 600,
    fontSize: 19,
    '& a': {
      color: '#fff',
      '&:hover': {
        color: '#aaa'
      }
    }
  },
  overTitle: {
    color: '#fff',
    lineHeight: 1.7,
    fontWeight: 'normal',
    fontSize: 12,
  },
  authorName: {
    fontSize: 10,
  },
  excerpt: {
    fontSize: 14,
    lineHeight: 2
  },
  footer: {
    marginBottom: 5
    // position: 'absolute',
    // bottom: 7
  }
})

